const PropTypes = require('prop-types');
const React = require('react');

const ComparisonShoppingListingTab = (props) =>
  <div>
    <div className="nav-tabs__tab__hydra-callout">
      {I18n.t(`comparisonShoppingPage.listingTab.${props.listingCondition}`)}
    </div>
    <div
      className="show-only-on-desktop"
      dangerouslySetInnerHTML={{
        __html: I18n.t('comparisonShoppingPage.listingTab.countFromPrice', { count: props.listingCount, price: props.lowPrice }),
      }}
    />
  </div>;

ComparisonShoppingListingTab.propTypes = {
  listingCount: PropTypes.number.isRequired,
  lowPrice: PropTypes.string.isRequired,
  listingCondition: PropTypes.string.isRequired,
};

module.exports = ComparisonShoppingListingTab;



// WEBPACK FOOTER //
// ./javascripts/components/comparison_shopping_page/comparison_shopping_listing_tab.jsx